module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAACCAYAAACnpNlpAAAAcklEQVQ4T+1RQQ6AMAhr2Z7oK/3kDAwI06gnbx4IpcAyWmLbBwkIicgLltmzCCxE83rmGYqbzijO2nvBveSu/eb7Pmtc8oKshei3s2I7dTbeuHAPf8pb8ub4m+viu6qP3R56VL0KPmvM34DVbDOpxNcGHNghB+/hzjhLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/titright.png
// module id = yzet
// module chunks = 2